document.addEventListener("DOMContentLoaded", () => {
    const allMessages = document.querySelectorAll('.grid__item.product[class*="bss-product-lock-"]');
    const redirectHPMessage = () => {
        window.location.href = '/pages/customer-signup-form';
    }
    allMessages.forEach(message => {
        message.addEventListener('click', redirectHPMessage)
    });
})